<template>
    <vm-container>
        <div class="row jc-space-between ai-center" v-if="!isEnvSelected">
            <vm-dropdown
                label="Target environment"
                title="name"
                :options="environments"
                v-model="selectedEnvironmentId"
            />
        </div>

        <div v-else>
            <div class="mb-3">

                <vm-button
                    @click="resetTargetEnv()"
                    class="ml-3 outlined-grey"
                    primaryColor="var(--triadic2-600)"
                >
                    RESET
                </vm-button>
            </div>
            <br>
            <div>
                <input
                        label="Account ID"
                        type="number"
                        v-model.number="filterData.accountId"
                        class="mr-3"
                    />
                    <input
                        label="Start Date"
                        type="date"
                        v-model="filterData.startDate"
                        class="mr-3"
                    />
                    <input
                        label="End Date"
                        type="date"
                        v-model="filterData.endDate"
                        class="mr-3"
                        />
                    <vm-button @click="applyFilters" class="outlined-grey">
                        Apply
                    </vm-button>

            </div>

            <div class="row jc-center mt-3">
                <button @click="getPrevPage" :disabled="currentPage == 1">Prev</button>
                <span class="mx-2">Page {{ currentPage }}</span>
                <button @click="getNextPage">Next</button>
            </div>
            <br>
            <div>
                <span class="mx-2">
                    Rows {{ (currentPage - 1) * 200 }} to {{ (currentPage - 1) * 200 + errorLogs.length }}
                </span>
            </div>

            <vm-card>
                <vm-grid
                    class="x-pagination-hidden"
                    :config="gridConfig"
                    :isLoading="isLoading"
                    :rowData="errorLogs"
                    :maxRows="200"
                >
                </vm-grid>
            </vm-card>

            <br>
            <div>
                <span class="mx-2">
                    Rows {{ (currentPage - 1) * 200 }} to {{ (currentPage - 1) * 200 + errorLogs.length }}
                </span>
            </div>
            <br>
            <div class="row jc-center mt-3">
                <button @click="getPrevPage" :disabled="currentPage == 1">Prev</button>
                <span class="mx-2">Page {{ currentPage }}</span>
                <button @click="getNextPage">Next</button>
            </div>
        </div>

        <div class="row-center" v-if="isLoadingEditor">
            <vm-loading-spinner :scale="0.5" />
        </div>
    </vm-container>
</template>

<script lang="ts">
// vue
import { defineComponent, onBeforeMount, ref, watch } from 'vue';

// services
import { useEnvironmentService } from '@/api/service/environment.service';
import { useEventLogService } from '@/api/service/event-log-service';

// hooks
// import { useToast } from 'vue-toastification';

// configs
import { errorLogConfig } from '@/config/event-log-config';

export default defineComponent({
    components: {},
    setup() {
        // services
        const { getErrorLog } = useEventLogService();
        const { environments, getEnvironmentAll } = useEnvironmentService();

        // hooks

        const errorLogs = ref<any>([])

        const isLoading = ref(true);
        const isEditing = ref(false);
        const isLoadingEditor = ref(false);
        const isEnvSelected = ref(false);

        const selectedEnvironmentId = ref(0);

        const currentPage = ref<number>(1);
        const isResetPage = ref(false)

        const filterData = ref<any>({
            accountId: 0,
            startDate: undefined,
            endDate: undefined
        })

        const populateTableData = async (): Promise<void> => {
            if (selectedEnvironmentId.value === 0) return;

            if(isResetPage.value){
                currentPage.value = 1;
            }

            try{
                isLoading.value = true;
                const res = await getErrorLog(
                                                        selectedEnvironmentId.value, 
                                                        currentPage.value, 
                                                        filterData.value.accountId, 
                                                        filterData.value.startDate, 
                                                        filterData.value.endDate
                                                    ); 
                errorLogs.value = [...(res||[])]
                isResetPage.value = false;
                isLoading.value = false;
            }
            catch(e){
                //@ts-ignore
                console.log("Error:", e)
            }
            finally{
                isLoading.value = false;
            }
        };

        const getNextPage = async () => {
            currentPage.value = currentPage.value + 1
            await populateTableData()
        }

        const getPrevPage = async () => {
            if(currentPage.value > 1){
                currentPage.value = currentPage.value - 1
                await populateTableData()
            }
        }

        const resetFilters = () => {
            filterData.value = {
                accountId: 0,
                startDate: undefined,
                endDate: undefined
            }
            currentPage.value = 1;
        }

        const resetTargetEnv = (): void => {
            resetFilters()
            selectedEnvironmentId.value = 0;
        };

        const applyFilters = async () => {
            await populateTableData()
        }

        // watch
        watch(
            selectedEnvironmentId,
            async (): Promise<void> => {
                isEnvSelected.value = !isEnvSelected.value;
                resetFilters();
                await populateTableData();
            },
        );

        watch(
            filterData,
            ()  => {
                isResetPage.value = true
            },
            { deep: true}
        );


        // lifecycle
        onBeforeMount(async () => {
            isLoading.value = true;

            await getEnvironmentAll();

            isLoading.value = false;
        });

        // configs
        const gridConfig = [
            ...errorLogConfig,
        ];

        return {
            isEditing,
            isLoading,
            gridConfig,
            errorLogs,
            environments,
            isEnvSelected,
            resetTargetEnv,
            isLoadingEditor,
            errorLogConfig,
            selectedEnvironmentId,
            getNextPage,
            getPrevPage,
            currentPage,
            filterData,
            applyFilters
        };
    },
});
</script>

<style scoped>
.outlined-grey {
    background-color: transparent;
    color: grey;
    border: 1px solid grey;
}

</style>

<style scoped>
.x-pagination-hidden div.pagination {
    display: none;
}
</style>